import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import { useMyContext } from "../Context/MyContext";
import "swiper/css";
import "swiper/css/autoplay";

const HomeCategorySlider = () => {
  const {
    setFilterCategory,
    setStatusFilter,
    currentCategory,
    setCurrentCategory,
  } = useMyContext();

  const [activeCategory, setActiveCategory] = useState(
    currentCategory || ""
  );

  // CHAREX category icons updated to purple
  const categories = [
    {
      name: "Household appliances",
      icon: "https://img.icons8.com/ios-filled/100/7b2cbf/washing-machine.png",
    },
    {
      name: "Perfume",
      icon: "https://img.icons8.com/ios-filled/100/7b2cbf/perfume-bottle.png",
    },
    {
      name: "Back to school",
      icon: "https://img.icons8.com/ios-filled/100/7b2cbf/school.png",
    },
    {
      name: "Wears",
      icon: "https://img.icons8.com/?size=100&id=10156&format=png&color=7B2CBF",
    },
    {
      name: "Furniture",
      icon: "https://img.icons8.com/ios-filled/100/7b2cbf/sofa.png",
    },
    {
      name: "Bags/Luggage",
      icon: "https://img.icons8.com/?size=100&id=s8hemyUhjWmK&format=png&color=7B2CBF",
    },
    {
      name: "Fashion items",
      icon: "https://img.icons8.com/?size=100&id=FEpUrWZOhjMI&format=png&color=7B2CBF",
    },
    {
      name: "Electronics & gadget",
      icon: "https://img.icons8.com/ios-filled/100/7b2cbf/smartphone.png",
    },
    {
      name: "Hairs",
      icon: "https://img.icons8.com/?size=100&id=10365&format=png&color=7B2CBF",
    },
  ];

  // Handle category selection
  const handleSelect = (cat) => {
    setActiveCategory(cat);
    setStatusFilter("All");
    setFilterCategory(cat);
    setCurrentCategory(cat);

    // Smooth scroll to cookingitems section
    const target = document.getElementById("cookingitems");

    if (target) {
      const offset = 100;
      const top =
        target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="mt-2 w-full max-w-6xl mx-auto">
      {/* ====== Swiper Carousel ====== */}
      <div className="rounded-2xl shadow-sm relative bg-gradient-to-r from-[#faf7ff] via-white to-[#f5fff8] py-3">
        <Swiper
          modules={[Autoplay]}
          slidesPerView={3}
          centeredSlides={true}
          spaceBetween={16}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          speed={1000}
          loop={true}
          className="!overflow-hidden px-4 sm:px-6 md:px-8"
        >
          {categories.map((cat, index) => (
            <SwiperSlide key={index}>
              <div
                onClick={() => handleSelect(cat.name)}
                className={`cursor-pointer w-24 sm:w-28 rounded-xl border shadow-sm flex flex-col items-center justify-center p-3 transition-all duration-300 mx-auto hover:scale-105 hover:-translate-y-1 hover:shadow-lg ${
                  activeCategory === cat.name
                    ? "border-[#7b2cbf] ring-2 ring-[#45c46f]/40 bg-[#f7f0ff]"
                    : "border-gray-200 bg-white hover:border-[#7b2cbf]"
                }`}
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mb-2">
                  <img
                    src={cat.icon}
                    alt={cat.name}
                    crossOrigin="anonymous"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://img.icons8.com/ios-filled/100/7b2cbf/shop.png";
                    }}
                    className="w-full h-full object-contain"
                  />
                </div>

                <h3
                  className="text-xs sm:text-sm font-semibold text-[#3b3b3b] text-center truncate w-full"
                  title={cat.name}
                >
                  {cat.name}
                </h3>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* ====== Category Tiles Section ====== */}
      <div className="px-4 sm:px-6 md:px-8 mt-6">
        <div className="bg-gradient-to-r from-[#7b2cbf] to-[#45c46f] text-white px-6 py-2 rounded-md shadow-md mb-2 text-center font-semibold inline-block">
          All Categories
        </div>

        {/* 3-column tile grid */}
        <div className="grid grid-cols-3 gap-y-0 gap-x-0 sm:gap-x-0">
          {categories.map((cat, index) => (
            <motion.div
              key={index}
              whileHover={{
                scale: 1.05,
                y: -4,
              }}
              onClick={() => handleSelect(cat.name)}
              className={`cursor-pointer rounded-2xl shadow-sm p-4 flex flex-col items-center justify-center text-center border transition-all duration-300 ${
                activeCategory === cat.name
                  ? "border-[#7b2cbf] ring-2 ring-[#45c46f]/40 bg-[#f7f0ff]"
                  : "border-gray-200 bg-gradient-to-b from-white to-[#faf7ff] hover:border-[#7b2cbf] hover:shadow-xl"
              }`}
            >
              <div className="w-12 h-12 sm:w-16 sm:h-16 mb-3 flex items-center justify-center">
                <img
                  src={cat.icon}
                  alt={cat.name}
                  crossOrigin="anonymous"
                  onError={(e) => {
                    e.currentTarget.src =
                      "https://img.icons8.com/ios-filled/100/7b2cbf/shop.png";
                  }}
                  className="w-full h-full object-contain"
                />
              </div>

              <h3
                className="text-xs sm:text-sm font-semibold text-[#3b3b3b] truncate w-full"
                title={cat.name}
              >
                {cat.name}
              </h3>

              <p className="text-[10px] sm:text-xs text-[#7b2cbf] font-semibold mt-1 transition-colors duration-300 hover:text-[#45a864]">
                SHOP NOW →
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeCategorySlider;